import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { AdjustmentDetail } from 'types';

export const disputeState = atom<AdjustmentDetail[]>({
    key: 'disputeState',
    default: []
});

export const useDisputeState = () => useRecoilValue(disputeState);

export const useSetDisputeState = () => useSetRecoilState(disputeState);